import { render, staticRenderFns } from "./IdeaBrainstorm.vue?vue&type=template&id=2700bc72"
import script from "./IdeaBrainstorm.vue?vue&type=script&lang=js"
export * from "./IdeaBrainstorm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports